import React, { Component } from 'react'
import MenuItem from './MenuItem'

interface MenuProps {
  onRoute: () => void
}

export default class Menu extends Component<MenuProps> {
  render () {
    return (
      <div className="bg-primary">
        <MenuItem
          name="subscribers"
          onRoute={this.props.onRoute} />
        <MenuItem
          name="sites"
          onRoute={this.props.onRoute} />
        <MenuItem
          name="users"
          onRoute={this.props.onRoute} />
        <MenuItem
          name="trials"
          onRoute={this.props.onRoute} />
        <MenuItem
          name="metas"
          onRoute={this.props.onRoute} />
        <MenuItem
          name="logout"
          onRoute={this.props.onRoute} />
      </div>
    )
  }
}
